import { useAuth } from "@/context/AuthContext";

/**
 * Read the currently-signed-in user's effective permission set.
 * Returns { has(code), hasAny(...codes), all: Set }.
 *
 * If the user hasn't loaded yet (`null`), `has()` returns `false` so guards
 * stay closed until we know. If the user has no `permissions` array (older
 * `/auth/me` response cached in an old SW), we fall back to a role-based
 * check for admin so the app never accidentally locks the admin out.
 */
export function usePermissions() {
  const { user } = useAuth();
  const set = new Set(Array.isArray(user?.permissions) ? user.permissions : []);
  const has = (code) => {
    if (!user) return false;
    if (set.size === 0) return user.role === "admin";
    return set.has(code);
  };
  const hasAny = (...codes) => codes.some((c) => has(c));
  return { has, hasAny, all: set };
}
